<template>
    <ul class="list-disc list-outside">
        <slot/>
    </ul>
</template>
